export default __webpack_public_path__ + "static/media/AnimalsRed_07.fb541633.png";